import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { Col } from 'antd';

import CustomSelect from '../../../../components/CustomSelect/CustomSelect';
import {
    oneClient,
    createClientDataStore,
    clientDataStore,
    clientDataStoreLoadingStatus,
    getClientDataStore,
} from '../../../../redux/slices/clientsSlice';

const optionsPriorities = [
    {
        id: 'email',
        label: 'Email',
        value: 'email',
    },
    {
        id: 'phone',
        label: 'Phone',
        value: 'phone',
    },
    {
        id: 'email_and_phone',
        label: 'Email and Phone',
        value: 'email_and_phone',
    },
];

const stylesSelect = {
    option: (provider, state) => ({
        ...provider,
        backgroundColor: state.isFocused ? '#e5e6ff' : 'transparent',
        color: 'hsl(0, 0%, 20%)',
        cursor: 'pointer',
        ':hover': {
            backgroundColor: 'e5e6ff',
        },
        ':active': {
            backgroundColor: 'e5e6ff',
        },
    }),
};

export const ClientCommunicationPriority = () => {
    const dispatch = useDispatch();
    const client = useSelector(oneClient);
    const communicationPriority = useSelector(clientDataStore);
    const communicationPriorityLoading = useSelector(
        clientDataStoreLoadingStatus,
    );
    const [selectedPriority, setSelectedPriority] = useState({});

    const currentOptionPriority = optionsPriorities.find(
        (option) => option?.id === communicationPriority.welcome_priority,
    );

    useEffect(() => {
        if (!client.client_uid) return;

        setSelectedPriority(currentOptionPriority);
    }, [client, communicationPriority, currentOptionPriority]);

    const onSelectChange = (option) => {
        setSelectedPriority(option);
        onSubmit(option);
    };

    const onSubmit = async (option) => {
        try {
            const data = {
                fields: [
                    {
                        key_name: 'welcome_priority',
                        value: option.id,
                    },
                ],
            };
            await dispatch(
                createClientDataStore({
                    id: client.client_uid,
                    body: data,
                    collectionName: 'clients',
                }),
            );
            await dispatch(
                getClientDataStore({
                    id: client.client_uid,
                    collectionName: 'clients',
                }),
            );
            toast.success('Changes saved successfully');
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <Col span={10}>
            <div
                className="form__item-wrapper"
                style={{ marginBottom: '32px' }}
            >
                <CustomSelect
                    labelText="Communication priority"
                    onChange={onSelectChange}
                    value={selectedPriority?.id}
                    options={optionsPriorities}
                    customStyles={stylesSelect}
                    name="Communication priority"
                    isLoading={communicationPriorityLoading === 'loading'}
                />
            </div>
        </Col>
    );
};
